import React from "react";
import {Grid, TimeNavbarPicker, Leap4Breadcrumbs, Box, useMediaQuery, useTheme} from "@leap4/frontend";
import {RootState} from "../../../../interfaces/root-state.interface";
import {setDatesRange} from "../../../../store/actions/dateRange.actions";
import {connect, ConnectedProps} from "react-redux";
import {IDateRangeGState} from "../../../../interfaces/datesGlobalState.interface";
import {MobileTimeNavbar} from "../../../shared/MobileTimeNavbar/MobileTimeNavbar";


const mapStateToProps = (state: RootState) => ({
    dates: state.dates,
});

const mapActions = {
    setDatesRange
}

const connector = connect(mapStateToProps, mapActions);

type PropsFromRedux = ConnectedProps<typeof connector>;

export interface IReportHeaderProps extends PropsFromRedux {
    breadcrumbsIcon?: JSX.Element
    breadcrumbs: {
        text: string
        link?: string,
        icon?: React.ReactElement
    }[]
    setDatesRange: (startDate: string, endDate: string) => void,
    dates: IDateRangeGState,
}

const ReportHeader = (props: IReportHeaderProps): JSX.Element => {

    const {breadcrumbs, dates, setDatesRange} = props;
    const {startDate, endDate, isLoadingAny} = dates;
    
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <>
            {isMobile ? (
                <MobileTimeNavbar
                    isLoading={isLoadingAny}
                    setDates={setDatesRange}
                    excludeTabs={[]}
                    dates={{startDate, endDate}}
                />
            ) : (
                <>
                    <Grid p={2}>
                        <TimeNavbarPicker
                            isLoading={isLoadingAny}
                            setDates={setDatesRange}
                            excludeTabs={[]}
                            dates={{startDate, endDate}}
                            topOffset={50}
                        />
                    </Grid>
                    <Box sx={{ height: { sm: '50px', lg: '10px' } }} />
                </>
            )}
            <Grid style={{marginTop: "0.5vh" }} className={"test"}>
                <Grid container justifyContent={"space-between"} alignItems="center">
                    <Grid>
                        <Leap4Breadcrumbs breadcrumbs={breadcrumbs}/>
                    </Grid>


                </Grid>
            </Grid>
        </>
    )
}

export default connector(ReportHeader)